import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createAlert,
  getAlerts,
  getAlertById,
  updateAlert,
  deleteAlert,
} from "../../../api/alerts_api";

export const createAlertAction = createAsyncThunk(
  "alerts/createAlert",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createAlert(formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getAlertsAction = createAsyncThunk(
  "alerts/getAlerts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAlerts();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getAlertByIdAction = createAsyncThunk(
  "alerts/getAlertById",
  async (alertID, { rejectWithValue }) => {
    try {
      const response = await getAlertById(alertID);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const updateAlertAction = createAsyncThunk(
  "alerts/updateAlert",
  async ({ alertID, formData }, { rejectWithValue }) => {
    try {
      const response = await updateAlert(alertID, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const deleteAlertAction = createAsyncThunk(
  "alerts/deleteAlert",
  async (alertID, { rejectWithValue }) => {
    try {
      const response = await deleteAlert(alertID);
      return { alertID, ...response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
